import React from 'react'
import { Translate } from 'react-redux-i18n'
import { formatCurrency, formatProfitLoss } from '../lib/currency-formatter'
import { BondClosedPosition, CouponInfo } from '../types'

export interface Props {
  position: BondClosedPosition
  currency: string
  locale: string
  // asset: Price;
}

const BondClosed = ({ position, currency, locale }: Props) => {
  const { closedTrade, bond, coupons } = position
  const positionPL = (closedTrade.closePrice - closedTrade.openPrice) * closedTrade.volume
  const paidInterest = coupons.reduce(
    (acc: number, coupon: CouponInfo) => (acc += coupon.amount),
    0
  )

  return (
    <div className="edit-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <table className="edit-wrapper__table">
              <tbody>
                <tr>
                  <td colSpan={2}>
                    <u className="color-75">
                      <Translate value={'positionDetails'} />
                    </u>
                  </td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'orderId'} />
                  </td>
                  <td>{closedTrade.id}</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'value'} />
                  </td>
                  <td>
                    {formatCurrency(
                      closedTrade.volume * closedTrade.closePrice,
                      bond.currency,
                      locale
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'leverage'} />
                  </td>
                  <td>{bond.leverage}X</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'openPrice'} />
                  </td>
                  <td>{formatCurrency(closedTrade.openPrice, bond.currency, locale)}</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'closePrice'} />
                  </td>
                  <td>{formatCurrency(closedTrade.closePrice, bond.currency, locale)}</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'profit'} />
                  </td>
                  <td className={positionPL > 0 ? 'positive' : 'negative'}>
                    {formatProfitLoss(positionPL, currency, locale)}
                  </td>
                </tr>

                <tr>
                  <td colSpan={2} className="sidebar__label">
                    <u className="color-75">
                      <Translate value={'interestDetails'} />
                    </u>
                  </td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'principalAmount'} />
                  </td>
                  <td>{formatCurrency(closedTrade.volume, bond.currency, locale)}</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'coupon'} />
                  </td>
                  <td>{bond.couponInterestRate}%</td>
                </tr>
                <tr>
                  <td className="pl-3">
                    <Translate value={'paidInterest'} />
                  </td>
                  <td className="positive">{formatCurrency(paidInterest, currency, locale)}</td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <sup className="bondBuyModeDisclamer">
                      <Translate value={'interestPaymentNote'} />
                    </sup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BondClosed
